module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page contact"
  }, [_c('div', {
    staticClass: "me"
  }, [_c('img', {
    staticClass: "me__pic",
    attrs: {
      "src": "/static/logo_wide.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "me__description"
  }, [_c('p', [_vm._v("\n          Bendpanic Production is a creative studio specialised in stop-motion and 2D animation run by director and visual artist Veronica Solomon. We work on bring ideas to life in charming and inspiring narratives connecting with the audience through meaning, emotions and original content with a focus on character driven storytelling.\nBased in Tampere - Finland, active worldwide.\n\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Our creative process draws on over 20 years of experience in artistic creation and animation production. We support our in-house animation services with a network of trusted and highly capable collaborators. Our portfolio includes a selection of original productions and commissioned works that best reflects our variety of style and techniques.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lists"
  }, [_c('div', {
    staticClass: "clients"
  }, [_c('h3', [_vm._v("Clients")]), _vm._v(" "), _c('ul', _vm._l((_vm.clients), function(client) {
    return _c('li', [_vm._v("\n                " + _vm._s(client) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('ul', _vm._l((_vm.contacts), function(contact) {
    return _c('li', [_c('a', {
      attrs: {
        "href": contact.href,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(contact.name) + "\n                ")])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3af938a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 120
// module chunks = 0